import { Signpost, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '../../ui/empty';

export function EmptyState(props: {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  /** Neutral tone must never render a zero-value in its title/description. */
  tone?: 'neutral' | 'blocked';
  /** `EmptyContent`'s own `max-w-sm` fits a single button; an action wider than that
   *  (a list, a picker) passes its own width class here rather than fighting the default. */
  contentClassName?: string;
}): ReactNode {
  const tone = props.tone ?? 'neutral';
  const Icon = props.icon ?? (tone === 'blocked' ? Signpost : undefined);
  return (
    // `border-dashed` on the primitive sets style, not width: without `border` this drew no card at all.
    <Empty className="border">
      <EmptyHeader>
        {Icon !== undefined && (
          <EmptyMedia variant="icon">
            <Icon aria-hidden />
          </EmptyMedia>
        )}
        <EmptyTitle>{props.title}</EmptyTitle>
        {props.description !== undefined && (
          <EmptyDescription>{props.description}</EmptyDescription>
        )}
      </EmptyHeader>
      {props.action !== undefined && (
        <EmptyContent className={props.contentClassName}>{props.action}</EmptyContent>
      )}
    </Empty>
  );
}
